import * as yup from "yup"

const emailRegex =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const guidRegex = /^[{(]?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}[)}]?$/

export const createAccountValidationSchema = yup.object({
    name: yup.string().required(),
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    email: yup.string().email().matches(emailRegex).required(),
    mobile: yup
        .string()
        .min(10)
        .max(10)
        .matches(/^[0-9]+$/)
        .required(),
})

export const forgotPasswordValidationSchema = yup.object({
    email: yup.string().email().matches(emailRegex).required(),
})

export const resetPasswordValidationSchema = yup.object({
    password: yup.string().required(),
    passwordRepeat: yup.string().required(),
    email: yup.string().email().matches(emailRegex).required(),
    guid: yup.string().matches(guidRegex, 'Invalid GUID format').required('GUID is required'),
})